import React from "react";

import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

const TitleBgCoursesQT = () => {
  return (
    <div className="QL__Sec__Titlebgpic">
      <div className="QL__Sec__Titlebgpic__bgcolor">
        <Container maxWidth="xl">
          <Grid
            container
            justifyContent="center"
            justifySelf="center"
            textAlign="center"
          >
            <Grid
              //   bgcolor="#F5F9FC"
              item
              xs={12}
              justifyContent="center"
              justifySelf="center"
              textAlign="center"
            >
              <div className="QL__PG__TitlebgpicQMHeading">
                {" "}
                Courses <br />
                <span className="QL__PG__TitlebgpicTitle">
                  Qur'an Translation
                </span>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>
    </div>
  );
};
export default TitleBgCoursesQT;
